import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const activeConsumerSelector = (state: RootState) => state.amwell.activeConsumer.information;

export const activeConsumerDataSelector = createSelector(activeConsumerSelector, ac => ac.data);

export const activeConsumerDataErrorSelector = createSelector(
  activeConsumerSelector,
  ac => ac.error
);
export const activeConsumerDataLoadingSelector = createSelector(
  activeConsumerSelector,
  ac => ac.loading
);
export const activeConsumerInsuranceStatusSelector = createSelector(
  activeConsumerSelector,
  ac => ac.insuranceStatus
);
